export const USERS_CONTEXTS = {
  ALL: "ALL",
  SUPERADMIN: "SUPERADMIN",
  PWC: "PWC",
  LUXEMBOURG_STAFF: "LU",
  CLIENT: "CLIENT",
};
